/* eslint-disable consistent-return */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-plusplus */
import React from 'react';
import PropTypes from 'prop-types';
import './css/FlightRoundTrip.css';
import {
  getForwardDepartureTime,
  getForwardArrivalTime,
  getBackwardDepartureTime,
  getBackwardArrivalTime,
  getForwardDepartureDate,
  getForwardDepartureAirport,
  getForwardArrivalDate,
  getForwardArrivalAirport,
  getBackwardDepartureDate,
  getBackwardDepartureAirport,
  getBackwardArrivalDate,
  getBackwardArrivalAirport,
  getForwardTotalTripTime,
  getBackwardTotalTripTime,
  getForwardCompaniesWithFlightId,
  getBackwardCompaniesWithFlightId,
  getArrivalAirportId,
  getDepartureAirportId,
  getTripStages,
} from '../../Utils/FlightUtils';
import {
  TO,
  BACK,
  FLIGHT_DETAILS,
  IN_TRIP,
  SLECT,
  CHEAPEST,
} from '../../Utils/Constants/GlobalConstants';
import { ReactComponent as Info } from '../../images/blue-info-r.svg';
import { ReactComponent as Plain } from '../../images/plain-r.svg';
import { formatPrice } from '../../Utils/CommonUtils';
import PriceText from '../PriceText/PriceText';

function FlightRoundTrip(props) {
  const {
    handleSelect,
    flight,
    isSelection,
    fromNode,
    toNode,
    detailsClick,
    cheapest,
  } = props;

  function getAddPay(fl) {
    const { cheapestPrice } = props;

    let result = '';

    if (cheapestPrice && cheapestPrice > 0 && fl.price) {
      if (fl.price.value && fl.price.value > cheapestPrice) {
        const dif = Math.ceil(
          parseInt(fl.price.value, 10) - parseInt(cheapestPrice, 10),
        );

        result = `+ ${formatPrice(dif)} ${fl.price.currency}`;
      }
    }

    return result;
  }

  function getPrice(fl) {
    let result = '-/-';

    if (fl.price) {
      const { currency, value } = fl.price;
      result = `${formatPrice(value)} ${currency}`;
    }

    return result;
  }

  function renderFlights(fl, isForward) {
    let companies;
    if (isForward) {
      companies = getForwardCompaniesWithFlightId(fl);
    } else {
      companies = getBackwardCompaniesWithFlightId(fl);
    }

    const content = [];

    for (let i = 0; i < companies.length; i++) {
      const company = companies[i];

      content.push(
        <div key={`flight-item-${i}`} className="frt_flight_item_w">
          <div className="bm_text_16 mb_6 frt_flight_item">
            {company.company ? company.company : ''}
          </div>
          {company.number && (
            <div className="gr_text_13 mb_2 frt_flight_item">
              {company.number}
            </div>
          )}
          {company.plane && (
            <div className="gr_text_13 mb_2">{company.plane}</div>
          )}
        </div>,
      );
    }

    return content;
  }

  function getTripVisualization(flights) {
    if (flights.length === 1) {
      return (
        <div>
          <div className="frt_gray_track mb_6"></div>
          <div className="frt_single_track_airports" style={{ width: '280px' }}>
            <div className="dbb_text_14">
              {getDepartureAirportId(flights[0])}
            </div>
            <div className="dbb_text_14">{getArrivalAirportId(flights[0])}</div>
          </div>
        </div>
      );
    } else if (flights.length === 2) {
      const periods = getTripStages(flights);

      return (
        <div>
          <div className="frt_track_w">
            <div
              className="frt_blue_track"
              style={{ width: `${periods[0].percent}%` }}
            ></div>
            <div
              className="frt_gray_track"
              style={{ width: `${periods[1].percent}%` }}
            ></div>
            <div
              className="frt_blue_track"
              style={{ width: `${periods[2].percent}%` }}
            ></div>
          </div>
          <div className="frt_airport_w">
            <div
              className="dbb_text_14"
              style={{
                width: `${periods[0].percent}%`,
                textAlign: 'left',
                marginRight: '5px',
              }}
            >
              {getDepartureAirportId(flights[0])}
            </div>
            <div
              className="dbb_text_14"
              style={{
                width: `${periods[1].percent}%`,
                textAlign: 'center',
                marginRight: '5px',
              }}
            >
              {getArrivalAirportId(flights[0])}
            </div>
            <div
              className="dbb_text_14"
              style={{
                width: `${periods[2].percent}%`,
                textAlign: 'right',
              }}
            >
              {getArrivalAirportId(flights[1])}
            </div>
          </div>
        </div>
      );
    } else if (flights.length === 3) {
      const periods = getTripStages(flights);

      return (
        <div>
          <div className="frt_track_w">
            <div
              className="frt_blue_track"
              style={{ width: `${periods[0].percent}%` }}
            ></div>
            <div
              className="frt_gray_track"
              style={{ width: `${periods[1].percent}%` }}
            ></div>
            <div
              className="frt_blue_track"
              style={{ width: `${periods[2].percent}%` }}
            ></div>
            <div
              className="frt_gray_track"
              style={{ width: `${periods[3].percent}%` }}
            ></div>
            <div
              className="frt_blue_track"
              style={{ width: `${periods[4].percent}%` }}
            ></div>
          </div>
          <div className="frt_airport_w">
            <div
              className="dbb_text_14"
              style={{
                width: `${periods[0].percent}%`,
                textAlign: 'left',
                marginRight: '5px',
              }}
            >
              {getDepartureAirportId(flights[0])}
            </div>
            <div
              className="dbb_text_14"
              style={{
                width: `${periods[1].percent}%`,
                textAlign: 'center',
                marginRight: '5px',
              }}
            >
              {getArrivalAirportId(flights[0])}
            </div>
            <div
              className="dbb_text_14"
              style={{
                width: `${periods[2].percent}%`,
                textAlign: 'center',
                marginRight: '5px',
              }}
            >
              {getDepartureAirportId(flights[1])}
            </div>
            <div
              className="dbb_text_14"
              style={{
                width: `${periods[3].percent}%`,
                textAlign: 'center',
                marginRight: '5px',
              }}
            >
              {getArrivalAirportId(flights[1])}
            </div>
            <div
              className="dbb_text_14"
              style={{ width: `${periods[4].percent}%`, textAlign: 'right' }}
            >
              {getDepartureAirportId(flights[2])}
            </div>
          </div>
        </div>
      );
    }
  }

  function getForwardVisualization(flights) {
    let result;
    if (flights.forward && flights.forward.length > 0) {
      result = getTripVisualization(flights.forward);
    }

    return result;
  }

  function getBackwardVisualization(flights) {
    let result;
    if (flights.backward && flights.backward.length > 0) {
      result = getTripVisualization(flights.backward);
    }

    return result;
  }

  return (
    <div className={`${cheapest ? 'frt_cheapest_padding' : ''}`}>
      <div
        className={
          isSelection
            ? 'frt_fligh_depart_selection_wrapper'
            : 'frt_fligh_depart_wrapper'
        }
      >
        {cheapest && (
          <div className="frt_cheapest_mark wm_text_14">{CHEAPEST}</div>
        )}
        {isSelection && (
          <div className="frt_ticket_selection_price">
            <div className="frt_ticket_selection_pay">
              <div className="bb_text_30 frt_ticket_price">
                <PriceText text={getPrice(flight)} />
              </div>
              <div className="rm_text_18">
                <PriceText text={getAddPay(flight)} />
              </div>
            </div>
            <button
              type="button"
              className="wm_text_18 blue_button frt_ticket_sel_but"
              onClick={() => handleSelect(flight)}
            >
              {SLECT}
            </button>
          </div>
        )}
        <div className="frt_ticket_content">
          <div className="frt_ticket_dir_col_1">
            <div
              className={`frt_fligh_first_line ${
                isSelection ? 'mb_16' : 'mb_30'
              }`}
            >
              <div className="bm_text_22">{TO}</div>
              {!isSelection && (
                <button
                  type="button"
                  className="frt_flight_det_but"
                  onClick={() => detailsClick(true)}
                  ref={(node) => {
                    if (toNode) {
                      toNode.current = node;
                    }
                  }}
                >
                  <div className="dbr_text_14">{FLIGHT_DETAILS}</div>
                  <Info className="frt_fligh_info_ico" />
                </button>
              )}
            </div>
            <div className="frt_fligh_second_line">
              <div className="frt_col_1">
                <div className="frt_time_w mb_10">
                  <Plain className="frt_direct_plain_ico" />
                  <div className="frt_flight_time">
                    {getForwardDepartureTime(flight)}
                  </div>
                </div>
                <div className="gr_text_14 mb_4">
                  {getForwardDepartureDate(flight)}
                </div>
                <div className="gr_text_14">
                  {getForwardDepartureAirport(flight)}
                </div>
              </div>
              <div className="frt_col_2">
                <div className="gr_text_14 mb_14">{`${IN_TRIP}: ${getForwardTotalTripTime(
                  flight,
                )}`}</div>
                <div className="frt_vis_w">
                  {getForwardVisualization(flight)}
                </div>
              </div>
              <div className="frt_col_3">
                <div className="frt_time_w mb_10">
                  <Plain className="frt_direct_plain_ico" />
                  <div className="frt_flight_time">
                    {getForwardArrivalTime(flight)}
                  </div>
                </div>
                <div className="gr_text_14 mb_4">
                  {getForwardArrivalDate(flight)}
                </div>
                <div className="gr_text_14">
                  {getForwardArrivalAirport(flight)}
                </div>
              </div>
            </div>
          </div>
          <div className="frt_ticket_dir_col_2">
            {renderFlights(flight, true)}
          </div>
        </div>
      </div>

      {/* flight back */}
      <div
        className={
          isSelection
            ? 'frt_fligh_return_selection_wrapper'
            : 'frt_fligh_return_wrapper'
        }
      >
        <div className="frt_ticket_dir_col_1">
          <div
            className={`frt_fligh_first_line ${
              isSelection ? 'mb_16' : 'mb_30'
            }`}
          >
            <div className="bm_text_22">{BACK}</div>
            {!isSelection && (
              <button
                type="button"
                className="frt_flight_det_but"
                onClick={() => detailsClick(false)}
                ref={(node) => {
                  if (fromNode) {
                    fromNode.current = node;
                  }
                }}
              >
                <div className="dbr_text_14">{FLIGHT_DETAILS}</div>
                <Info className="frt_fligh_info_ico" />
              </button>
            )}
          </div>
          <div className="frt_fligh_second_line">
            <div className="frt_col_1">
              <div className="frt_time_w mb_10">
                <Plain className="frt_direct_plain_ico" />
                <div className="frt_flight_time">
                  {getBackwardDepartureTime(flight)}
                </div>
              </div>
              <div className="gr_text_14 mb_4">
                {getBackwardDepartureDate(flight)}
              </div>
              <div className="gr_text_14">
                {getBackwardDepartureAirport(flight)}
              </div>
            </div>
            <div className="frt_col_2">
              <div className="gr_text_14 mb_14">{`${IN_TRIP}: ${getBackwardTotalTripTime(
                flight,
              )}`}</div>
              {getBackwardVisualization(flight)}
            </div>
            <div className="frt_col_3">
              <div className="frt_time_w mb_10">
                <Plain className="frt_direct_plain_ico" />
                <div className="frt_flight_time">
                  {getBackwardArrivalTime(flight)}
                </div>
              </div>
              <div className="gr_text_14 mb_4">
                {getBackwardArrivalDate(flight)}
              </div>
              <div className="gr_text_14">
                {getBackwardArrivalAirport(flight)}
              </div>
            </div>
          </div>
        </div>
        <div className="frt_ticket_dir_col_2">
          {renderFlights(flight, true)}
        </div>
      </div>
    </div>
  );
}

FlightRoundTrip.propTypes = {
  handleSelect: PropTypes.func,
  flight: PropTypes.instanceOf(Object).isRequired,
  cheapestPrice: PropTypes.number,
  isSelection: PropTypes.bool,
  fromNode: PropTypes.instanceOf(Object),
  toNode: PropTypes.instanceOf(Object),
  detailsClick: PropTypes.func,
  cheapest: PropTypes.bool,
};

FlightRoundTrip.defaultProps = {
  handleSelect: null,
  cheapestPrice: null,
  isSelection: false,
  fromNode: null,
  toNode: null,
  detailsClick: null,
  cheapest: false,
};

export default FlightRoundTrip;
